import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminLinkBuilder from "@/pages/AdminLinkBuilder";
import StaffAdminGate from "@/components/StaffAdminGate";

export const Route = createFileRoute("/admin/link-builder")({
  head: () => seoHead("/admin/link-builder"),
  component: () => (
    <StaffAdminGate><AdminLinkBuilder /></StaffAdminGate>
  ),
});
